'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _qs = require('qs');

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RESPONSE_HEADERS = { 'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Headers': 'Authorization' };

var RestClientDriver = function () {
    function RestClientDriver(_ref) {
        var nockable = _ref.nockable,
            _ref$environment = _ref.environment,
            environment = _ref$environment === undefined ? 'node' : _ref$environment;

        _classCallCheck(this, RestClientDriver);

        this._nockable = nockable;
        this._environment = environment;
    }

    _createClass(RestClientDriver, [{
        key: 'start',
        value: function start() {
            return this._nockable.start();
        }
    }, {
        key: 'stop',
        value: function stop() {
            return this._nockable.stop();
        }
    }, {
        key: 'reset',
        value: function reset() {
            return this._nockable.reset();
        }
    }, {
        key: 'on',
        value: function on(path) {
            var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';

            var _this2 = this;

            var params = arguments[2];
            var auth = arguments[3];


            var _nockParams = { path: path, method: method };

            _nockParams.headers = {
                Accept: 'application/json'
            };

            if (auth) {
                if (typeof auth === 'string') {
                    _nockParams.headers.Authorization = 'Bearer ' + auth;
                } else {
                    _nockParams.headers.Authorization = auth.type + ' ' + auth.credentials;
                }
            }

            if (method === 'get' && params) {
                _nockParams.query = params;
            }

            if (method !== 'get' && params) {
                _nockParams.data = params;
            }

            var _this = {
                delayBy: function delayBy(_ref2) {
                    var ms = _ref2.ms;

                    _nockParams.delay = ms;
                    return _this;
                },

                succeedWith: function succeedWith(response) {
                    _nockParams.response = response;

                    _this2._addRule(_nockParams);
                },

                failWith: function failWith(_ref3) {
                    var type = _ref3.type,
                        title = _ref3.title,
                        status = _ref3.status,
                        detail = _ref3.detail;

                    _nockParams.response = { type: type, title: title, status: status, detail: detail };
                    _nockParams.status = status;

                    _this2._addRule(_nockParams);
                },

                failWithProtocolError: function failWithProtocolError() {
                    _nockParams.response = '<html></html>';

                    _this2._addRule(_nockParams);
                }
            };

            return _this;
        }
    }, {
        key: '_addRule',
        value: function _addRule(_ref4) {
            var path = _ref4.path,
                method = _ref4.method,
                query = _ref4.query,
                headers = _ref4.headers,
                data = _ref4.data,
                _ref4$delay = _ref4.delay,
                delay = _ref4$delay === undefined ? 0 : _ref4$delay,
                _ref4$status = _ref4.status,
                status = _ref4$status === undefined ? 200 : _ref4$status,
                response = _ref4.response;

            var _nock = this._nockable.nock;
            var queryIndex = path.indexOf('?');

            if (queryIndex > -1) {
                var queries = _qs2.default.parse(path.substr(queryIndex + 1));
                query = Object.assign({}, query, queries);
                path = path.substring(0, queryIndex);
            }

            if (this._environment === 'browser') {
                _nock = _nock.options(path);
                if (query) {
                    _nock = _nock.query(query);
                }
                _nock = _nock.reply(200, null, RESPONSE_HEADERS);
            }

            _nock = _nock[method](path, data);
            _lodash2.default.each(headers, function (value, key) {
                _nock = _nock.matchHeader(key, value);
            });
            _nock = _nock.query(query);
            _nock = _nock.delayConnection(delay);
            _nock = _nock.times(-1);
            _nock.reply(status, response, RESPONSE_HEADERS);
        }
    }]);

    return RestClientDriver;
}();

exports.default = RestClientDriver;


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-restaurants-js-sdk/dist/testkit/RestClientDriver.js
// module id = 731
// module chunks = 0